import request from '@/utils/request'
import { GetWaitVolumePredictionReq, WaitVolumePredictionRes } from './types'

/** 출고대기수량 예측 조회 (LOGISPRD-8369) */
export const getWaitVolumePrediction = (params: GetWaitVolumePredictionReq) =>
  request.get<ApiResponseV2<WaitVolumePredictionRes>, GetWaitVolumePredictionReq>('/api/v1/outbound/wait-volume/prediction', params)
